import { SvgIconProps } from '@mui/material';
import { JSX } from 'react';

export enum UploadStatus {
	PAUSED = 'Paused',
	UPLOADING = 'Uploading',
	ERROR = 'Error',
	COMPLETE = 'Complete',
}

export enum ProcessingStatus {
	IN_PROGRESS,
	FINISHED,
	ERRORED,
}

export enum Processors {
	ANPR,
	CELLEBRITE_SHEET,
	CELLEBRITE_XML,
	STELLAR_CELLEBRITE,
	AXIOM,
	//GENERIC,
}

export type SheetProcessingRecord = Record<string, boolean>;

export interface Field {
	value: string | number | boolean | string[];
	helperText?: string | string[];
	error?: boolean;
	errorText: Set<string>;
	required?: boolean;
}

export type FieldState = Record<string, Field>;

export type PipelineLevels = 'INFO' | 'WARN' | 'ERROR' | 'SUCCESS' | 'FATAL';

export type SystemRoles =
	| 'VIEW'
	| 'UPLOAD'
	| 'UPLOAD_AXIOM'
	| 'UPLOAD_STELLAR'
	| 'CREATE_OP'
	| 'MANAGE_OP'
	| 'FAQS'
	| 'SUPERUSER'
	| 'DEVELOPER'
	| 'MANAGE_ORG'
	| 'ADMINISTRATOR'
	| 'MSHT'
	| 'ENRICH_LANGUAGE'
	| 'ENRICH_SUMMARY'; // for future summarisation enrichment

export enum FeatureFlag {
	NEW_UPLOAD_FORM,
	AXIOM,
	STELLAR,
}

export type DuplicatePreference = 'INSERT' | 'ASK' | 'DISCARD';

export interface PrometheusTab {
	name: string;
	icon: React.ElementType<SvgIconProps>;
	component?: JSX.Element;
	marginTop?: number;
	helpText: string;
	requiredRoles?: SystemRoles[];
	defaultChild?: number;
	children?: PrometheusTab[];
}

export interface UploadReason {
	reason: string;
	onBehalfOf: boolean;
	onBehalfOfName?: string;
	onBehalfOfEmail?: string;
}

export interface FAQ {
	question: string;
	answer: string;
	link: string;
}
